<!--财务中心 客户结算(团餐) 详情 -->
<template>
  <div>
    <el-row>
      <el-col>
        <el-form :model="searchForm" ref="searchForm" :inline="true" style="margin-top: 20px">
          <el-form-item label="项目点：">
            <el-select size="medium" filterable v-model="searchForm.PROJECT" placeholder="请选择" clearable>
              <el-option v-for="item in points" :key="item.value" :label="item.PROJECT_NAME" :value="item.PROJECT_ID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="送货日期：">
            <el-date-picker size="medium" v-model="searchForm.SEND_DAY" type="date" placeholder="选择日期" clearable
              format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd">></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" @click="doQueryTable()" type="primary" :loading="loading">筛选</el-button>
            <el-button size="medium" @click="exportQueryTable()" type="primary" plain :loading="loading">导出</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="6">
        <h6 style="margin-top: 10px">
          订单个数:<span>{{ this.orderCount }}&nbsp;个</span>
        </h6>
      </el-col>
      <el-col :span="6">
        <h6 style="margin-top: 10px">
          总金额:<span>{{ this.totalFree }}&nbsp;元</span>
        </h6>
      </el-col>
      <el-col :span="2" :offset="10">
        <el-button size="small" @click="openAdd" style="margin-top: 20px; margin-bottom: 10px"
          v-if="this.tcStatus == '开始结算'">上传发票</el-button>
        <el-button size="small" @click="openEdit" style="margin-top: 20px; margin-bottom: 10px"
          v-if="this.tcStatus == '已开发票'">修改发票</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table :data="balanceOrderList" border stripe show-summary style="width: 100%">
          <el-table-column type="index" width="50" min-width="30" label="序号"></el-table-column>
          <el-table-column prop="ORDER_CODE" label="订单编号" min-width="270"></el-table-column>
          <el-table-column prop="SEND_DAY" label="送货日期" min-width="135"></el-table-column>
          <el-table-column prop="TC_NAME" label="公司" min-width="90"></el-table-column>
          <el-table-column prop="PROJECT_NAME" label="项目点" min-width="100"></el-table-column>
          <el-table-column prop="DK_NAME" label="档口" min-width="100"></el-table-column>
          <el-table-column prop="REAL_TOTAL_WEIGHT" label="数量" min-width="100"></el-table-column>
          <el-table-column prop="REAL_TOTAL_SUPPLIER_FEE" label="金额" min-width="100"></el-table-column>
          <el-table-column prop="ORDER_STATUS" label="状态" min-width="100"></el-table-column>
          <el-table-column fixed="right" label="操作" width="350">
            <template slot-scope="scope">
              <el-button type="text" size="small" icon="el-icon-view" @click="detail(scope.row)">查看</el-button>
              <el-button type="text" size="small" v-if="showLable(scope.row) !== 0" icon="el-icon-message"
                @click="send(scope.row)">寄单</el-button>
              <el-button type="text" size="small" v-if="showLable(scope.row) !== 0" icon="el-icon-message"
                @click="orderContract(scope.row)">订单资质</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <el-col :span="24" style="text-align: right">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="totalCount"></el-pagination>
      </el-col>
    </el-row>
    <!-- 新增模态框 -->
    <el-dialog title="新增发票" center :visible.sync="addFormVisible" width="600px">
      <el-form ref="addForm" v-model="addForm" size="small">
        <el-upload class="upload-demo" action="/uploadFile" ref="upload" :on-success="handleSuccess"
          :on-remove="handleRemove" :before-remove="beforeRemove" :name="this.addForm.invoice" multiple
          :on-exceed="handleExceed" :file-list="fileList">
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">
            只能上传jpg/png文件，且不超过500kb
          </div>
        </el-upload>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="close('addForm')">取 消</el-button>
        <el-button size="small" @click="submitInvoice('addForm')" :loading="loadAdd">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 修改模态框 -->
    <el-dialog title="修改发票" center :visible.sync="editFormVisible" width="600px">
      <el-form ref="editForm" v-model="editForm">
        <el-upload class="upload-demo" action="/uploadFile" ref="upload" :on-success="handleSuccess"
          :on-remove="removeFile" :before-remove="beforeRemove" :name="this.editForm.invoice" multiple
          :on-exceed="handleExceed" :file-list="fileList1">
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">
            只能上传jpg/png文件，且不超过500kb
          </div>
        </el-upload>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="close('editForm')">取 消</el-button>
        <el-button size="small" @click="submitEdit('editForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  TCOrderDetailFun, sendOrderFun, addInvoice, getInvoiceFun, delInvoiceFun,
} from 'api/tcBanlance';
import date from '@/assets/common/date';
import http from '@/assets/common/http';

export default {
  data() {
    return {
      balanceOrderList: [],
      loading: false,
      loadAdd: false,
      searchForm: {},
      totalFree: 0,
      currentPage: 1,
      totalCount: 0,
      pageSize: 10,
      tcStatus: '',
      orderCount: 0,
      points: [],
      addFormVisible: false,
      addForm: {
        invoice: 'invoice',
      },
      editForm: {
        invoice: 'invoice',
      },
      editFormVisible: false,
      fileList: [],
      fileList1: [],
      urlArray: [],
      idArray: [],
    };
  },
  computed: {
    TC_ORDER_LIST_CONDITION() {
      return this.$store.state.TC_ORDER_LIST_CONDITION;
    },
  },
  methods: {
    close(formName) {
      this.$refs[formName].resetFields();
      const modalName = `${formName}Visible`;
      this[`${modalName}`] = false;
      this.fileList = [];
      this.fileList1 = [];
    },
    // -------------------------------------上传发票------------------------------待修改
    openAdd() {
      this.addFormVisible = true;
    },
    submitInvoice(formName) {
      const params = {
        BALANCE_ID: Number(sessionStorage.getItem('balanceId')),
        PIC_URLS: this.urlArray,
      };
      this.loadAdd = true;
      addInvoice(params)
        .then((result) => {
          this.$message.show({ text: '操作成功', type: 'success' });
          this.fileList = [];
          this.$refs.upload.clearFiles();
          this.close(formName);
          this.loadAdd = false;
          this.queryDataList();
        }).catch((error) => {
          this.loadAdd = false;
          this.fileList = [];
          this.$refs.upload.clearFiles();
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // ---------------------------------------修改
    openEdit() {
      this.editFormVisible = true;
      this.getInvioce();
    },
    // ------------------------------------获取上传的发票名称
    getInvioce() {
      const params = {
        BALANCE_ID: Number(sessionStorage.getItem('balanceId')),
      };
      getInvoiceFun(params)
        .then((result) => {
          let i;
          for (i = 0; i < result.length; i++) {
            let str = result[i].PIC_URL;
            str = str.substring(str.lastIndexOf('/'));
            str = str.split('/').join('');
            const temp = {};
            temp.name = str;
            temp.uid = result[i].ID;
            // temp.url = "https://service.linkda.com.cn/file/invoice"
            temp.url = 'http://47.99.59.146/uploadFile';
            this.fileList1.push(temp);
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    submitEdit(formName) {
      if ((this.idArray.length != 0) && (this.urlArray.length != 0)) {
        this.submitInvoice(formName);
        this.deleteInvoice(formName);
        this.close(formName);
      } else if ((this.urlArray.length != 0) && (this.remove == '')) {
        this.submitInvoice(formName);
        this.close(formName);
      } else if ((this.remove != '') && (this.urlArray.length == 0)) {
        this.deleteInvoice(formName);
        this.close(formName);
      } else {
        this.close(formName);
      }
    },
    // -----------------------------------------删除
    deleteInvoice() {
      const params = {
        IDS: this.idArray,
      };
      delInvoiceFun(params)
        .then((result) => {
          this.$message.show({ text: '操作成功', type: 'success' });
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // ----------------------------------------成功函数
    handleSuccess(response, file, fileList) {
      this.url = response.base_url + response.file_name;
      this.urlArray.push({ PIC_URL: this.url });
    },
    // ---------------------------------------handleRemove
    handleRemove(file, fileList) {
      this.urlArray.forEach((item, index) => {
        if (item.PIC_URL.indexOf(file.response.file_name) !== -1) {
          this.urlArray.splice(index, 1);
        }
      });
    },
    // ----------------------------------------移除
    removeFile(file, fileList) {
      this.remove = file.uid;
      this.idArray.push({ ID: this.remove });
    },
    // ----------------------------------------上传文件成功函数
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    handleCurrentChange() {
      this.queryDataList();
    },
    // -------------------------------------获取项目点
    queryProjectFun() {
      const params = {
        SERVICE_ID: '10005',
        OTYPE: 18,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        TC_ID: Number(sessionStorage.getItem('ID')),
      };
      // getTCTitle(params)
      http.post(params)
        .then((result) => {
          // this.points = result[0].list;
          this.points = result.length > 0 ? result : [];
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // ----------------------------------------寄单
    send(row) {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            ORDER_ID: Number(row.ORDER_ID),
          };
          sendOrderFun(params).then((result) => {
            this.$message.show({ text: '操作成功', type: 'success' });
            this.queryDataList();
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {}
      }
    },
    // ----------------------------------------判断寄单状态
    showLable(row) {
      switch (row.ORDER_STATUS) {
        case '已确认':
          return '寄单';
        default:
          return 0;
      }
    },
    // ----------------------------------------订单资质
    orderContract() {
      this.$router.push({ name: 'tcSettlementContract' });
    },
    // ------------------------------------------------查看
    detail(row) {
      this.$router.push({ path: '/tcBalanceDayList/detail' });
      sessionStorage.setItem('ORDER_ID', row.ORDER_ID);
    },
    // ------------------------------------------------拉取企业团餐详情页面
    queryDataList() {
      const params = {
        TC_ID: Number(sessionStorage.getItem('ID')),
        MONTH: sessionStorage.getItem('MONTH'),
        PAGEINDEX: this.currentPage - 1,
        PAGESIZE: this.pageSize,
      };
      if (this.searchForm.SEND_DAY) {
        params.SEND_DAY = this.searchForm.SEND_DAY;
      }
      if (this.searchForm.PROJECT) {
        params.PROJECT_ID = this.searchForm.PROJECT;
      }
      this.loading = true;
      TCOrderDetailFun(params)
        .then((result) => {
          if (result.length !== 0) {
            this.totalCount = result[0].TOTAL_COUNT;
            this.tcStatus = sessionStorage.getItem('tcStatus');
            this.totalFree = sessionStorage.getItem('COST');
            this.orderCount = result[0].TOTAL_COUNT;
            this.balanceOrderList = result[0].list;
            this.$store.dispatch('SET_TC_ORDER_LIST_CONDITION', {
              // CONDITION: this.searchForm,
              CURRENT_PAGE: this.currentPage,
            });
            this.balanceOrderList.forEach((element) => { // tableData你的数据源
              switch (element.ORDER_STATUS) {
                case 7:
                  element.ORDER_STATUS = '已确认';
                  break;
                case 8:
                  element.ORDER_STATUS = '已寄单';
                  break;
                case 9:
                  element.ORDER_STATUS = '部分收单';
                  break;
                case 10:
                  element.ORDER_STATUS = '全量收单';
                  break;
                default:
                  element.ORDER_STATUS = '状态未翻译';
              }
              this.status = element.ORDER_STATUS;
            });
          } else {
            this.balanceOrderList = [];
            this.$message.show({ text: '暂无数据', type: 'success' });
          }
          this.loading = false;
        }).catch((error) => {
          this.loading = false;
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // ------------------------------------------------搜索
    doQueryTable() {
      this.currentPage = 1;
      this.queryDataList();
    },
    // 导出
    exportQueryTable() {
      const params = {
        SERVICE_ID: '10010',
        OTYPE: 16,
        TC_ID: Number(sessionStorage.getItem('ID')),
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        // SUPPLIER_ID: sessionStorage.getItem('ID'),
        MONTH: sessionStorage.getItem('MONTH'),
      };
      if (this.searchForm.SEND_DAY) {
        params.SEND_DAY = date(this.searchForm.SEND_DAY, '%F');
      }
      if (this.searchForm.PROJECT) {
        params.PROJECT_ID = this.searchForm.PROJECT;
      }
      http.post(params).then((res) => {
        window.location.href = res[0].FILE_PATH;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.TC_ORDER_LIST_CONDITION.CONDITION) {
      this.currentPage = this.TC_ORDER_LIST_CONDITION.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.queryDataList();
    this.queryProjectFun();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/financeCenter/tcOrderList.vue